import { cardItems } from '@/mocks/homepage';

export default function Cards() {
  return (
    <section id="cards" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-movie-2-line text-xl text-primary-500"></i>
              <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading">
                精选推荐
              </h2>
            </div>
            <p className="text-sm text-foreground-500">编辑精选 · 品质之选</p>
          </div>
          <a href="#index" className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer">
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {cardItems.map((item, idx) => (
            <div
              key={item.id}
              className={`group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                idx === 6 ? 'sm:col-span-2 lg:col-span-1 xl:col-span-1' : ''
              }`}
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-[10px] font-semibold rounded-md">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 font-heading line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex sm:hidden justify-center mt-6">
          <a href="#index" className="flex items-center gap-1 text-sm text-primary-500 font-medium cursor-pointer">
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}